var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.72 13.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5370",
    "data-name": "Group 5370"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    d: "M27.71,12.1C26.67,4.45,19.63-.91,11.98.13,5.75.97.86,5.87.01,12.1c-.1.93.57,1.77,1.5,1.87.06,0,.13.01.2.01h24.3c.94,0,1.7-.75,1.71-1.69,0-.07,0-.13-.01-.2M16.32,10.77c-.57,1.11-1.94,1.55-3.06.98-1.11-.57-1.55-1.94-.98-3.06.22-.42.56-.76.98-.98l6.25-3.2-3.2,6.26Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack11);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-11.45b3a88db896d72c183fb8bedc16ef24.svg";
export { ForwardRef as ReactComponent };